const invoicePairingStatusReducer = (pairing_status = true, action) => {
    switch (action.type) {
        case "ADD_INVOICE_PAIRING_STATUS":
            return action.payload;
        default:
            return pairing_status;
    }
};

export default invoicePairingStatusReducer;